import { StandardLink } from 'components/standardLink/standardLink';
import * as React from 'react';

export const ScheduleLabLink: React.FC = () => <StandardLink to="/">https://schedulelab.io</StandardLink>;
